import { REPLAY_LIST_API, SUBJECT_NAME_API } from '@constants/api';
import _axios from '@plugins/_axios';

/**
 * 获取视频回放列表
 * @param {String} sort 排序 asc: 升序 desc：降序
 * @param {Number} undo 未做题 1：未做
 * @param {Number} subject_id 科目名称
 * @param {String} name 课程名称
 * @param {Number} page 第几页
 * @param {Number} limit 每页显示多少条
 */
export function getReplayList({
    sort = 'desc',
    undo = 0,
    subject_id,
    name = '',
    page = 1,
    limit = 20
}) {
    return _axios.post(REPLAY_LIST_API, {
        sort,
        undo,
        subject_id,
        name,
        page,
        limit
    });
}
/**
 * 获取科目列表
 */
export function getSubjectList() {
    return _axios.get(SUBJECT_NAME_API);
}
